// Angular
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// Auth
import { AlertNoticeService } from '../../../../core/alert/alert.service';
// Service
import { AuthService } from '../../../../core/services/auth.service';

@Component({
	selector: 'kt-forgot-password',
	templateUrl: './forgot-password.component.html',
	encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit {
	// Public params
	forgotPasswordForm: FormGroup;
	loading = false;
	showAlert = false;

	constructor(
		private auth: AuthService,
		public authNoticeService: AlertNoticeService,
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef
	) {}
	/**
	 * On init
	 */
	ngOnInit() {
		this.initRegistrationForm();
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initRegistrationForm() {
		this.forgotPasswordForm = this.fb.group({
			email: ['', Validators.compose([Validators.required, Validators.email])]
		});
	}

	/**
	 * Form Submit
	 */
	submit(form) {
		this.loading = true;
		this.showAlert = false;
		if (form.valid) {
			this.auth.rememberPassword(form.value).subscribe((_res) => {
				this.loading = false;
				this.authNoticeService.setNotice('Correo enviado, por favor verifique su email para restablecer su contraseña', 'success');
				this.showAlert = true;
				setTimeout(() => this.router.navigateByUrl('/auth/login'), 5000)
				this.cdr.markForCheck();
			  }, (_err) => {
				this.loading = false;
				this.authNoticeService.setNotice('El correo suministrado no se encuentra registrado', 'danger');
				this.showAlert = true;
				this.cdr.markForCheck();
			  })
		} else {
			this.loading = false;
			Object.keys(form.controls).forEach(controlName =>
				form.controls[controlName].markAsTouched()
			);
			return;
		}
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.forgotPasswordForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result =
			control.hasError(validationType) &&
			(control.dirty || control.touched);
		return result;
	}
}
